import { Turbo } from "@hotwired/turbo-rails";
import { createApp, h } from "vue";
import { createI18n } from "vue-i18n";
import { createInertiaApp } from "@inertiajs/vue3";
import buffer from "buffer";
import "../controllers/index";

if (document.getElementById("app")?.hasAttribute("data-page")) {
  const i18n = createI18n({
    legacy: false,
    locale: window.printavo?.currentLocale ?? "en",
    messages: window.printavo?.localeData ?? {},
  });

  createInertiaApp({
    progress: false,

    resolve: (name) => {
      const pages = import.meta.glob("../vue/pages/**/*.vue");
      return pages[`../vue/pages/${name}.vue`]();
    },

    setup({ el, App, props, plugin }) {
      createApp({ render: () => h(App, props) })
        .use(i18n)
        .use(plugin)
        .mount(el);
    },
  });
}

Turbo.session.drive = document.querySelector("body[data-driven-by-turbo]") !== null;

// Filestack uploading buffer
window.Buffer = window.Buffer || buffer.Buffer;
